import ComisionesApi from '../../apis/Comisiones'

export default {
    namespaced: true,
    state: {
        comisiones: [],
        categorias: [],
        marcas: [],
        unidadMedidas: [],
        categoria_id:null,
        marca_id: null,
        unidadMedida_id: null,
        tipoProductos:[
            'MATERIAL', 'REACTIVO'
        ],
        tipoProducto: null
    },
    mutations: {
        set_brands (state, comisiones) {
            state.comisiones = comisiones
        },
        set_categoria (state, categoria) {
            state.categorias = categoria
        },
        set_marca (state, marca) {
            state.marcas = marca
        },
        set_unidadMedida (state, unidadMedida) {
            state.unidadMedidas = unidadMedida
        },
        set_categoria_id (state, categoria_id) {
            state.categoria_id = categoria_id
        },
        set_marca_id (state, marca_id) {
            state.marca_id = marca_id
        },
        set_unidadMedida_id (state, unidadMedida_id) {
            state.unidadMedida_id = unidadMedida_id
        },
        set_tipoProducto(state, tipoProducto){
            state.tipoProducto = tipoProducto
        }
    },
    actions: {
        async getComisiones({commit, dispatch}, filters) {
            return await ComisionesApi.get_all(filters)
                        .then( response => {
                            commit('set_brands', response.data)
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar registros, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async store({dispatch}, comision) {
            return await ComisionesApi.store(comision)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'El registro se realizó de forma correcta.'
                                }, {root: true});
                                dispatch('getComisiones')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al registrar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async update({dispatch}, comision) {
            return await ComisionesApi.update(comision)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La actualización se realizó de forma correcta'
                                }, {root: true});
                                dispatch('getComisiones')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al actualizar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async change_status({dispatch}, comision) {
            let action = (comision.active) ? 'inactivación' : 'activación';
            return await ComisionesApi.change_status(comision)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La ' + action + ' se relizó de forma correcta.'
                                }, {root: true});
                                dispatch('getComisiones')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la ' + action + ', vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async change_pagar({dispatch}, form) {
            return await ComisionesApi.change_pagar(form)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La se relizó de forma correcta.'
                                }, {root: true});
                                dispatch('getComisiones')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al realizar la, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async delete({dispatch}, comision) {
            return await ComisionesApi.delete(comision)
                            .then( response => {
                                dispatch('notifications/store_notification', {
                                    type: 'success',
                                    message: 'La eliminación se realizó de forma correcta.'
                                }, {root: true});
                                dispatch('getComisiones')
                            })
                            .catch( error => {
                                if (error.response?.status === 401) return null
                                dispatch('notifications/store_notification', {
                                    type: 'error',
                                    message: 'Ocurrió un error al eliminar, vuelva a intentarlo.'
                                }, {root: true});
                            })
        },
        async getExcelForComissions({dispatch}, filters){
            return await ComisionesApi.get_excel_for_comissions(filters)
                        .then( response => {
                            return response.data;
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar, vuelva a intentarlo.'
                            }, {root: true});
                        })
        }
    }
}